export default {
  horasAusente: {
    value: null,
    required: true,
    state: null,
    options: [
      { text: '1 Hora', value: 1 },
      { text: '2 Horas', value: 2 },
      { text: '3 Horas', value: 3 },
      { text: '4 Horas', value: 4 },
      { text: '5 Horas', value: 5 },
      { text: '6 Horas', value: 6 },
      { text: '7 Horas', value: 7 },
      { text: '8 Horas', value: 8 },
      { text: '9 Horas', value: 9 },
      { text: '10 Horas', value: 10 },
      { text: '11 Horas', value: 11 },
      { text: '12 Horas', value: 12 },
      { text: '13 Horas', value: 13 },
      { text: '14 Horas', value: 14 },
      { text: '15 Horas', value: 15 },
      { text: '16 Horas', value: 16 },
      { text: '17 Horas', value: 17 },
      { text: '18 Horas', value: 18 },
      { text: '19 Horas', value: 19 },
      { text: '20 Horas', value: 20 },
      { text: '21 Horas', value: 21 },
      { text: '22 Horas', value: 22 },
      { text: '23 Horas', value: 23 },
      { text: '24 Horas', value: 24 }
    ]
  },
  mensagem: {
    value: null,
    required: true,
    state: null
  },
  finalizaConversa: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros_atendimento/mensagensAusencia/components/addForm.js